import {CoachingReviewTypeActions} from 'stores/coaching/CoachingReviewTypeStore';

export default CoachingReviewTypeActions;
